import {REPORT_ELIGIBLE_FOR_QSB} from '/enum/records.enum';

export default {
  reportName: REPORT_ELIGIBLE_FOR_QSB,
};
